import { Component }      from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerStatementFieldsComponent } from './customer.statement-fields.component';
import { CustomerStatementSettingsModel }   from './typings/customer.statement-settings';

@Component({
  selector   : 'wor-customer-statement-settings',
  template: require('./customer.statement-settings.component.html')
})
export class CustomerStatementSettingsComponent {
  settings: CustomerStatementSettingsModel = CustomerStatementFieldsComponent.getDefaultSettings();

  constructor (
    public activeModal: NgbActiveModal
  ) {}

  confirm () : void {
    this.activeModal.close({ ...this.settings });
  }
}
